import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { ApiEndpoints } from './ApiConstants';

let stompClient = null;
const subscriptions = {};
const pendingSubscriptions = [];

export const connectToMatch = (matchId, onMessageReceived, onReconnect) => {
    if (stompClient && stompClient.connected) {
        if (!subscriptions[matchId]) {
            console.log('Subscribing to new match:', matchId);
            subscriptions[matchId] = stompClient.subscribe(`/api/topic/match/${matchId}`, (message) => {
                const data = JSON.parse(message.body);
                onMessageReceived(data);
            });
        }
        return;
    }

    pendingSubscriptions.push({ matchId, onMessageReceived, onReconnect });

    if (stompClient) return;

    const socket = new SockJS(ApiEndpoints.WS_URL);
    stompClient = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        onConnect: () => {
            console.log('WebSocket connected!');
            console.log('Pending subscriptions:', pendingSubscriptions.length);
            pendingSubscriptions.forEach(({ matchId, onMessageReceived, onReconnect, topic }) => {
                if (!subscriptions[matchId]) {
                    const subscribeTopic = topic || `/api/topic/match/${matchId}`;
                    console.log('Subscribing to topic:', subscribeTopic);
                    subscriptions[matchId] = stompClient.subscribe(subscribeTopic, (message) => {
                        console.log('Message received on topic:', subscribeTopic);
                        const data = JSON.parse(message.body);
                        onMessageReceived(data);
                    });
                }
                if (onReconnect) onReconnect(matchId);
            });
            pendingSubscriptions.length = 0;
        },
        onDisconnect: () => {
            console.log('WebSocket disconnected!');
            stompClient = null;
        }
    });
    stompClient.activate();
};

export const connectToLiveMatches = (ruleId, onMatchesReceived) => {
    const key = `live-matches-${ruleId}`;
    if (stompClient && stompClient.connected) {
        if (!subscriptions[key]) {
            subscriptions[key] = stompClient.subscribe(`/api/topic/live-matches/${ruleId}`, (message) => {
                const data = JSON.parse(message.body);
                console.log('🏏 Live matches update received:', data);
                onMatchesReceived(data);
            });
        }
        return;
    }
    pendingSubscriptions.push({
        matchId: key,
        onMessageReceived: onMatchesReceived,
        topic: `/api/topic/live-matches/${ruleId}`
    });
};

export const unsubscribeFromMatch = (matchId) => {
    if (subscriptions[matchId]) {
        subscriptions[matchId].unsubscribe();
        delete subscriptions[matchId];
    }
};

export const disconnectFromMatch = () => {
    if (stompClient) {
        stompClient.deactivate();
        stompClient = null;
        Object.keys(subscriptions).forEach(key => delete subscriptions[key]);
        pendingSubscriptions.length = 0;
    }
};